import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import SpatialNavigation from 'spatial-navigation-js';
import { Suspense, lazy, useEffect } from 'react';

const Home = lazy(() => import('./pages/Home'));
const Movies = lazy(() => import('./pages/Movies'));
const TVShows = lazy(() => import('./pages/TVShows'));
const MovieDetail = lazy(() => import('./pages/MovieDetail'));
const TVShowDetail = lazy(() => import('./pages/TVShowDetail'));
const SearchResults = lazy(() => import('./pages/SearchResults'));
const LiveTV = lazy(() => import('./pages/LiveTV'));

function App() {
  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isTV = userAgent.includes('tv') || userAgent.includes('smarttv') || userAgent.includes('tizen') || userAgent.includes('webos') || userAgent.includes('bingehq-tv');
    if (isTV) {
      SpatialNavigation.init();
      SpatialNavigation.add({
        selector: 'a, button, input, select, .focusable, [tabindex], video',
      });
      SpatialNavigation.makeFocusable();
      SpatialNavigation.focus();
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-[#090A0F] dark:bg-[#090A0F] text-slate-100 lg:pl-64 flex flex-col font-sans transition-colors duration-300">
        <Navbar />
        <main className="flex-1 flex flex-col min-w-0 overflow-x-hidden pt-2">
          <Suspense fallback={
            <div className="flex flex-col items-center justify-center min-h-[85vh]">
              <div className="w-14 h-14 border-4 border-orange-500 border-t-transparent rounded-full animate-spin" />
              <p className="mt-4 text-xs font-bold text-slate-400 uppercase tracking-wider font-display">
                Loading BingeHQ...
              </p>
            </div>
          }>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/movies" element={<Movies />} />
              <Route path="/tv-shows" element={<TVShows />} />
              <Route path="/movie/:id" element={<MovieDetail />} />
              <Route path="/tv-show/:id" element={<TVShowDetail />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/livetv" element={<LiveTV />} />
            </Routes>
          </Suspense>
          <Footer />
        </main>
      </div>
    </Router>
  );
}

export default App;